// Drives DevExtreme's own 3-phase custom-summary protocol (start / calculate / finalize)
// so a `summary.calculateCustomSummary` option already configured on a live grid can be
// reused verbatim by a from-scratch renderer, without DevExtreme itself in the loop.
// DevExtreme calls this same callback the same way internally; see grid.option('summary.*')
// in the devextreme d.ts (SummaryType includes 'custom', CustomSummaryInfo has
// { component, name, summaryProcess, value, totalValue }, and the callback mutates
// `info.totalValue` in place across calls rather than returning anything).
export function runCustomSummary(calculateCustomSummary, name, rows, component) {
    if (typeof calculateCustomSummary !== 'function') return undefined;

    const info = { component, name, summaryProcess: 'start', value: undefined, totalValue: undefined };
    calculateCustomSummary(info);

    info.summaryProcess = 'calculate';
    rows.forEach((row) => {
        info.value = row;
        calculateCustomSummary(info);
    });

    info.summaryProcess = 'finalize';
    calculateCustomSummary(info);

    return info.totalValue;
}
